<template>
  <div @click="closeBranchesModal">
    <edit-data
      v-if="addNewDataSidebarEdit"
      :isSidebarActive="addNewDataSidebarEdit"
      @closeSidebar="toggleDataSidebarEdit"
      :orderId="sidebarDataEdit"
      :pageName="pageName"
    />
    <Modal v-if="popupResend || popupResendWithNewOrder" @closeModal="closePopup()">
      <template v-slot:icon>
        <vs-alert
          :active="resendRequestErr"
          color="danger"
          icon="new_releases"
          class="mb-2"
        >
          <span>{{ resendRequestErrMsg ? resendRequestErrMsg : message }}</span>
        </vs-alert>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="96"
          height="96"
          viewBox="0 0 96 96"
        >
          <defs>
            <clipPath id="clip-path">
              <rect
                id="Rectangle_1485"
                data-name="Rectangle 1485"
                width="48.096"
                height="40.144"
                fill="#31006f"
              />
            </clipPath>
          </defs>
          <g
            id="Group_2175"
            data-name="Group 2175"
            transform="translate(-672 -363)"
          >
            <circle
              id="Ellipse_454"
              data-name="Ellipse 454"
              cx="48"
              cy="48"
              r="48"
              transform="translate(672 363)"
              fill="rgba(49,0,111,0.1)"
            />
            <g
              id="Group_2327"
              data-name="Group 2327"
              transform="translate(696 390.999)"
            >
              <g
                id="Group_2326"
                data-name="Group 2326"
                transform="translate(0 0)"
                clip-path="url(#clip-path)"
              >
                <path
                  id="Path_3348"
                  data-name="Path 3348"
                  d="M44.408,16.418a2.19,2.19,0,0,0,.063-.309V4.21a2.232,2.232,0,0,0-4.463,0v6.745L34.616,5.888a20.082,20.082,0,0,0-33.135,7.5,2.231,2.231,0,0,0,4.206,1.49A15.644,15.644,0,0,1,25.623,5.358a15.873,15.873,0,0,1,5.887,3.731l5.1,4.791h-6.27a2.232,2.232,0,0,0,0,4.463h11.9a2.224,2.224,0,0,0,.872-.177c.018-.007.033-.029.055-.037a2.205,2.205,0,0,0,.67-.471l.033-.018a2.426,2.426,0,0,0,.18-.294,2.3,2.3,0,0,0,.258-.416,2.214,2.214,0,0,0,.1-.511"
                  transform="translate(3.626 -0.001)"
                  fill="#31006f"
                />
                <path
                  id="Path_3349"
                  data-name="Path 3349"
                  d="M41.631,8.04A2.24,2.24,0,0,0,38.783,9.4,15.785,15.785,0,0,1,35.1,15.237a15.651,15.651,0,0,1-22.136-.055l-5.1-4.791H14.13a2.232,2.232,0,1,0,0-4.463H2.23L2.2,5.935a2.124,2.124,0,0,0-.618.125,1.746,1.746,0,0,0-.232.052,2.111,2.111,0,0,0-.291.2,2.2,2.2,0,0,0-.427.305l-.026.018A2.094,2.094,0,0,0,.438,6.9a2.235,2.235,0,0,0-.272.438,2.117,2.117,0,0,0-.1.5A1.861,1.861,0,0,0,0,8.158v11.9a2.232,2.232,0,1,0,4.463,0V13.317l5.394,5.07a20.107,20.107,0,0,0,28.4,0,20.249,20.249,0,0,0,4.736-7.5A2.232,2.232,0,0,0,41.631,8.04"
                  transform="translate(0 15.884)"
                  fill="#31006f"
                />
              </g>
            </g>
          </g>
        </svg>
      </template>
      <template v-slot:content>
        <p class="modal-content">سنقوم بتسجيل طلب إعادة إرسال الطلب</p>
      </template>
      <template v-slot:first-btn>
        <button class="first-btn" v-if="!loadingResend">
          <span @click="resendOrderRequest(2)" v-if="popupResendWithNewOrder">{{ $t('confirmReturnOrderWithNewOrder') }}</span>
          <span @click="resendOrderRequest(1)" v-else>{{ $t('confirmResendOrder') }}</span>
        </button>
        <button class="first-btn" v-else>
          <span><spinner-color /></span>
        </button>
      </template>
    </Modal>
    <modal-rate v-if="popupRate" @closeModal="closePopup()">
      <template v-slot:content>
        <h4>تقييم الخدمة</h4>
        <vs-alert
          :active="errMsg"
          color="danger"
          icon="new_releases"
          class="mb-3"
        >
          <span>
            {{ message ? message : "حدث خطأ ما برجاء المحاولة مره اخري" }}</span
          >
        </vs-alert>
        <div class="input">
          <h6>مستوي التقييم</h6>
          <div class="rate flex items-center">
            <div
              @click="activeRate(rate)"
              class="single-ticket"
              :class="rate.classNameParent"
              v-for="(rate, index) in rates"
              :key="index"
            >
              <img :src="rate.imgSrc" />
              {{ rate.name }}
            </div>
          </div>
        </div>
        <div class="input">
          <h6>ملاحظات</h6>
          <textarea
            cols="30"
            rows="30"
            v-model="description"
            name="description"
            v-validate="'required|min:3'"
          ></textarea>
          <span
            v-if="rateVlaue != 5 && rateVlaue != 4"
            style="
              font-size: 0.7rem;
              transform: translateY(-28px);
              display: block;
            "
            class="text-danger font-bold"
            >{{ errors.first("description") }}</span
          >
        </div>
      </template>
      <template v-slot:first-btn>
        <span
          @click="confirmRateOrder"
          v-if="!confirmRateLoad"
          class="w-full flex justify-center"
          >تقييم الأن</span
        >
        <span v-else class="flex justify-center">
          <spinner-color />
        </span>
      </template>
    </modal-rate>

    <modal-rate v-if="popupResendWithSaveOrder" @closeModal="closePopup()">
      <template v-slot:content>
        <h4>كود الطلب</h4>
        <vs-alert
          :active="resendRequestErr"
          color="danger"
          icon="new_releases"
          class="mb-2"
        >
          <span>{{ message }}</span>
        </vs-alert>
        <div class="input">
          <h6>الكود</h6>
          <input v-model="orderId" type="text" placeholder="مثال : 3305487" />
        </div>
      </template>
      <template v-slot:first-btn>
        <span v-if="!loadingResend" @click="resendOrderRequest(2)">تأكيد</span>
        <span v-else><spinner-color /></span>
      </template>
    </modal-rate>

    <div class="title-page flex justify-between text-center items-center">
      <div class="flex items-center">
        <feather-icon icon="PackageIcon" svgClasses="h-4 w-4"></feather-icon>
        <h3
          class="font-bold ml-3"
          style="display: inline-block; font-size: 1.125rem"
        >
          {{ $t("orderDetails") }}
        </h3>
        <button
          class="ml-5 office-given-btn font-bold"
          v-if="success && detail_of_order.order_type == 2"
        >
          <i>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17.042"
              height="17.042"
              viewBox="0 0 17.042 17.042"
            >
              <g
                id="Icon_feather-alert-octagon"
                data-name="Icon feather-alert-octagon"
                transform="translate(-2.25 -2.25)"
              >
                <path
                  id="Path_2502"
                  data-name="Path 2502"
                  d="M7.554,3h6.434l4.554,4.554v6.434l-4.554,4.554H7.554L3,13.988V7.554Z"
                  transform="translate(0 0)"
                  fill="none"
                  stroke="#ff9f43"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
                <path
                  id="Path_2503"
                  data-name="Path 2503"
                  d="M18,12v3.108"
                  transform="translate(-7.229 -4.337)"
                  fill="none"
                  stroke="#ff9f43"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
                <path
                  id="Path_2504"
                  data-name="Path 2504"
                  d="M18,24h0"
                  transform="translate(-7.229 -10.121)"
                  fill="none"
                  stroke="#ff9f43"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
              </g>
            </svg>
          </i>
          الطلب تسليم مكتب
        </button>
        <button
          class="ml-5 office-given-btn font-bold"
          v-if="success && detail_of_order.is_fragile == 1"
        >
          <i>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17.042"
              height="17.042"
              viewBox="0 0 17.042 17.042"
            >
              <g
                id="Icon_feather-alert-octagon"
                data-name="Icon feather-alert-octagon"
                transform="translate(-2.25 -2.25)"
              >
                <path
                  id="Path_2502"
                  data-name="Path 2502"
                  d="M7.554,3h6.434l4.554,4.554v6.434l-4.554,4.554H7.554L3,13.988V7.554Z"
                  transform="translate(0 0)"
                  fill="none"
                  stroke="#ff9f43"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
                <path
                  id="Path_2503"
                  data-name="Path 2503"
                  d="M18,12v3.108"
                  transform="translate(-7.229 -4.337)"
                  fill="none"
                  stroke="#ff9f43"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
                <path
                  id="Path_2504"
                  data-name="Path 2504"
                  d="M18,24h0"
                  transform="translate(-7.229 -10.121)"
                  fill="none"
                  stroke="#ff9f43"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
              </g>
            </svg>
          </i>
          {{ $t("securePackaging") }}
        </button>
        <button
          class="ml-5 nationl-shipping-btn font-bold"
          v-if="success && detail_of_order.is_international"
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 23 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.7448 1.81274C17.7095 0.816259 19.3036 0.803368 20.2843 1.78411C21.2382 2.73799 21.2559 4.27896 20.3243 5.25456L17.5456 8.16433C17.3278 8.3924 17.219 8.50644 17.1518 8.64C17.0924 8.75823 17.0571 8.88708 17.0478 9.01907C17.0374 9.16818 17.0728 9.32182 17.1438 9.62911L18.8717 17.1167C18.9444 17.4321 18.9808 17.5898 18.9691 17.7423C18.9587 17.8774 18.921 18.0089 18.8582 18.1289C18.7873 18.2645 18.6729 18.3789 18.444 18.6078L18.0732 18.9786C17.4671 19.5847 17.164 19.8878 16.8538 19.9427C16.583 19.9906 16.3043 19.9248 16.0835 19.7608C15.8306 19.573 15.695 19.1664 15.424 18.3532L13.4142 12.3239L10.0689 15.6692C9.8692 15.8689 9.76935 15.9687 9.70257 16.0863C9.6434 16.1905 9.60343 16.3044 9.58456 16.4227C9.56326 16.5563 9.57885 16.6966 9.61004 16.9773L9.79375 18.6307C9.82493 18.9113 9.84053 19.0517 9.81923 19.1852C9.80036 19.3035 9.76039 19.4174 9.70122 19.5216C9.63444 19.6392 9.53459 19.739 9.33491 19.9387L9.1374 20.1362C8.66434 20.6093 8.42781 20.8458 8.16496 20.9143C7.93442 20.9744 7.68999 20.9502 7.47571 20.8461C7.2314 20.7273 7.04585 20.449 6.67475 19.8924L5.10643 17.5399C5.04013 17.4404 5.00698 17.3907 4.96849 17.3456C4.9343 17.3056 4.89701 17.2683 4.85694 17.2341C4.81184 17.1956 4.76212 17.1624 4.66267 17.0961L2.31018 15.5278C1.75354 15.1567 1.47521 14.9712 1.35649 14.7269C1.25236 14.5126 1.22816 14.2681 1.28824 14.0376C1.35674 13.7747 1.59327 13.5382 2.06633 13.0652L2.26384 12.8677C2.46352 12.668 2.56337 12.5681 2.68095 12.5013C2.78511 12.4422 2.89906 12.4022 3.01736 12.3833C3.15089 12.362 3.29123 12.3776 3.5719 12.4088L5.22529 12.5925C5.50596 12.6237 5.6463 12.6393 5.77983 12.618C5.89813 12.5991 6.01208 12.5592 6.11624 12.5C6.23382 12.4332 6.33366 12.3334 6.53335 12.1337L9.87867 8.78835L3.84939 6.77859C3.03616 6.50752 2.62955 6.37198 2.44176 6.11907C2.27777 5.89823 2.212 5.6196 2.2599 5.34874C2.31477 5.03855 2.61784 4.73547 3.22399 4.12933L3.59476 3.75856C3.82365 3.52967 3.9381 3.41522 4.07369 3.34433C4.1937 3.28158 4.3252 3.24387 4.46023 3.23347C4.61278 3.22172 4.77049 3.25812 5.0859 3.3309L12.545 5.05224C12.855 5.12377 13.01 5.15953 13.1596 5.14889C13.3041 5.13862 13.4446 5.09709 13.5714 5.02718C13.7028 4.95476 13.8134 4.84049 14.0347 4.61196L16.7448 1.81274Z"
              stroke="#F44336"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          طلب دولي
        </button>
        <button
          class="ml-5 cancel-order-btn"
          v-if="success && detail_of_order.on_cancellation == 1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="11.997"
            viewBox="0 0 12 11.997"
          >
            <path
              id="Icon_ionic-ios-close"
              data-name="Icon ionic-ios-close"
              d="M18.707,17.287,22.993,13a1,1,0,0,0-1.42-1.42l-4.286,4.286L13,11.581A1,1,0,1,0,11.581,13l4.286,4.286-4.286,4.286A1,1,0,0,0,13,22.993l4.286-4.286,4.286,4.286a1,1,0,0,0,1.42-1.42Z"
              transform="translate(-11.285 -11.289)"
              fill="#e80505"
            />
          </svg>
          الطلب قيد الإلغاء
        </button>
        <button class="ml-5 urgent-action" v-if="detail_of_order.is_urgent">
          <svg
            width="16"
            height="16"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 14L8 11M11 14C12.3968 13.4687 13.7369 12.7987 15 12M11 14V19C11 19 14.03 18.45 15 17C16.08 15.38 15 12 15 12M8 11C8.53214 9.61943 9.2022 8.29607 10 7.05C11.1652 5.18699 12.7876 3.65305 14.713 2.5941C16.6384 1.53514 18.8027 0.986375 21 1C21 3.72 20.22 8.5 15 12M8 11H3C3 11 3.55 7.97 5 7C6.62 5.92 10 7 10 7M3.5 15.5C2 16.76 1.5 20.5 1.5 20.5C1.5 20.5 5.24 20 6.5 18.5C7.21 17.66 7.2 16.37 6.41 15.59C6.02131 15.219 5.50929 15.0046 4.97223 14.988C4.43516 14.9714 3.91088 15.1537 3.5 15.5Z"
              stroke="#FF5730"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          الطلب مستعجل
        </button>
        <button class="ml-5 is-deposit-action" v-if="detail_of_order.is_order == 4">
           {{ $t('isOrderReceivingDeposit') }}
        </button>
        <button class="ml-5 is-bank-payment" v-if="detail_of_order.is_bank_payment">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9L12 3L21 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M6 10V18M10 10V18M14 10V18M18 10V18" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" />
            <path d="M4 18H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
          {{ $t('BankPaymentService') }}
        </button>
      </div>
      <div class="flex items-center" v-if="success">
        <!-- Ticket -->
        <vx-tooltip
          text="عرض تذاكر الدعم"
          position="bottom"
          delay=".2s"
          v-if="
            Array.isArray(detail_of_order.tickets) &&
            detail_of_order.tickets.length
          "
        >
          <i
            class="mr-4 cursor-pointer"
            @click="toTicket(detail_of_order.tickets)"
          >
            <feather-icon
              icon="HeadphonesIcon"
              svgClasses="h-6 w-6"
            ></feather-icon>
          </i>
        </vx-tooltip>

        <!-- Phone Log -->
        <vx-tooltip :text="$t('orderPhoneLog')" position="bottom" delay=".2s">
          <i
            class="mr-4 cursor-pointer"
            @click="
              googleEventTrack(
                'الضغط على زر سجل مكالمات الطلب',
                'order_details',
                'phone_log_of_order'
              ),
                $router
                .push('/phoneLog/' + detail_of_order.id + '/order')
                .catch(() => {})
            "
          >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-phone-call font-medium-5"><path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>

          </i>
        </vx-tooltip>

        <!-- Chat -->
        <vx-tooltip
          v-if="
            $acl.not.check('isPublicCompany') &&
            this.detail_of_order.client_status != this.statusOfOrder.saved &&
            this.detail_of_order.client_status != this.statusOfOrder.sent
          "
          text="عرض المحادثة"
          position="bottom"
          delay=".2s"
        >
          <i
            class="mr-4 cursor-pointer"
            @click="
              googleEventTrack(
                'الضغط على ايقون الشات داخل تفاصيل الطلب',
                'order_details',
                'chat_of_order'
              );
              $router
                .push({
                  path: '/apps/chat/' + detail_of_order.id,
                  query: { type: 2 },
                })
                .catch(() => {});
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <path
                id="message-circle"
                d="M21,11.5a8.38,8.38,0,0,1-.9,3.8A8.5,8.5,0,0,1,12.5,20a8.38,8.38,0,0,1-3.8-.9L3,21l1.9-5.7A8.38,8.38,0,0,1,4,11.5,8.5,8.5,0,0,1,8.7,3.9,8.38,8.38,0,0,1,12.5,3H13a8.48,8.48,0,0,1,8,8Z"
                transform="translate(-2 -2)"
                fill="none"
                stroke="#6e6b7b"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
          </i>
        </vx-tooltip>

        <!-- LOG -->
        <vx-tooltip :text="$t('logOrder')" position="bottom" delay=".2s">
          <i
            class="mr-4 cursor-pointer"
            @click="
              googleEventTrack(
                'الضغط على زر سجل الطلب',
                'order_details',
                'log_of_order'
              ),
                $router
                  .push('/Log/' + detail_of_order.id + '/order')
                  .catch(() => {})
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <path
                id="Icon_awesome-history"
                data-name="Icon awesome-history"
                d="M18.563,9.545A9,9,0,0,1,3.914,16.57a.87.87,0,0,1-.067-1.292l.409-.409A.873.873,0,0,1,5.414,14.8,6.678,6.678,0,1,0,4.987,4.7L6.829,6.539a.581.581,0,0,1-.411.991H1.143A.581.581,0,0,1,.563,6.95V1.674a.581.581,0,0,1,.991-.411L3.345,3.055a9,9,0,0,1,15.217,6.49ZM12,12.4l.356-.458a.871.871,0,0,0-.153-1.222L10.724,9.575V5.788a.871.871,0,0,0-.871-.871H9.272a.871.871,0,0,0-.871.871v4.923l2.374,1.846A.871.871,0,0,0,12,12.4Z"
                transform="translate(-0.563 -0.563)"
                fill="#6e6b7b"
              />
            </svg>
          </i>
        </vx-tooltip>

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4">
          <div
            class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full"
          >
            <feather-icon
              icon="SettingsIcon"
              svgClasses="h-4 w-4"
              class="mr-2"
            />
            <span class="mr-2">{{ $t("actions") }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <ul style="min-width: 11rem">
              <vs-dropdown-item class="m-0 p-0">
                <li
                  @click="
                    googleEventTrack(
                      'الضغط على اكشن الطباعة',
                      'order_details',
                      'print_order_action'
                    ),
                      $router
                        .push(`/printOrder/${$route.params.id}`)
                        .catch(() => {})
                  "
                  class="flex py-4 px-4 cursor-pointer profile-drop"
                >
                  <feather-icon
                    icon="FileIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>{{ $t("print") }}</span>
                </li>
              </vs-dropdown-item>
              <vs-divider class="m-0" />
              <vs-dropdown-item
                class="m-0 p-0"
                v-if="detail_of_order.client_status == statusOfOrder.saved"
                @click.stop="
                  googleEventTrack(
                    'الضغط على اكشن الحذف',
                    'order_details',
                    'delete_order_action'
                  ),
                    popupActiveMethod(detail_of_order.code)
                "
              >
                <li class="flex py-4 px-4 cursor-pointer profile-drop">
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>{{ $t("delete") }}</span>
                </li>
                <vs-divider class="m-0" />
              </vs-dropdown-item>
              <!-- Mission Actions for Saved Orders -->
              <!-- <template v-if="detail_of_order.client_status == statusOfOrder.saved">
                <vs-dropdown-item class="m-0 p-0" @click.stop="openAddToMissionModal(detail_of_order)">
                  <li class="flex py-4 px-4 cursor-pointer profile-drop">
                    <feather-icon icon="PlusCircleIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>إضافة لمهمة استلام</span>
                  </li>
                </vs-dropdown-item>
                <vs-divider class="m-0" />
              </template> -->
              <!-- Pending Pickup Actions -->
              <!-- <template v-if="detail_of_order.client_status == statusOfOrder.pendingPickup">
                <vs-dropdown-item class="m-0 p-0" @click.stop="removeFromMission(detail_of_order)">
                  <li class="flex py-4 px-4 cursor-pointer profile-drop">
                    <feather-icon icon="MinusCircleIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>إزالة من المهمة</span>
                  </li>
                </vs-dropdown-item>
                <vs-divider class="m-0" />
              </template> -->
              <!-- <vs-dropdown-item
                class="m-0 p-0"
                v-if="
                  detail_of_order.client_status == statusOfOrder.saved ||
                  detail_of_order.client_status == statusOfOrder.sent
                "
                @click.stop="changeOrderState(detail_of_order.code)"
              >
                <li class="flex py-4 px-4 cursor-pointer profile-drop">
                  <feather-icon
                    icon="RefreshCcwIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>{{
                    detail_of_order.client_status == statusOfOrder.saved
                      ? $t("transToSent")
                      : "تحويل الي المحفوظة"
                  }}</span>
                </li>
              </vs-dropdown-item> -->
              <vs-dropdown-item class="m-0 p-0" v-if="loadingCancelation">
                <li
                  class="flex items-center justify-center py-4 px-4 cursor-pointer profile-drop"
                >
                  <spinner-color />
                </li>
              </vs-dropdown-item>
              <template v-else-if="!loadingCancelation">
                <vs-dropdown-item
                  class="m-0 p-0"
                  v-if="canBeCancelled"
                >
                  <li
                    @click="orderCancelation(1)"
                    v-if="detail_of_order.on_cancellation == 0"
                    class="flex items-center py-4 px-4 cursor-pointer profile-drop"
                  >
                    <svg
                      class="mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="11.997"
                      viewBox="0 0 12 11.997"
                    >
                      <path
                        id="Icon_ionic-ios-close"
                        data-name="Icon ionic-ios-close"
                        d="M18.707,17.287,22.993,13a1,1,0,0,0-1.42-1.42l-4.286,4.286L13,11.581A1,1,0,1,0,11.581,13l4.286,4.286-4.286,4.286A1,1,0,0,0,13,22.993l4.286-4.286,4.286,4.286a1,1,0,0,0,1.42-1.42Z"
                        transform="translate(-11.285 -11.289)"
                        fill="#e80505"
                      />
                    </svg>
                    <span style="color: #e80505">طلب إلغاء الطلب</span>
                  </li>
                  <li
                    @click="orderCancelation(0)"
                    v-else
                    class="flex items-center py-4 px-4 cursor-pointer profile-drop"
                  >
                    <svg
                      class="mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16.909"
                      height="16.661"
                      viewBox="0 0 16.909 16.661"
                    >
                      <g
                        id="Icon_feather-check-circle"
                        data-name="Icon feather-check-circle"
                        transform="translate(-2.052 -2.082)"
                      >
                        <path
                          id="Path_3343"
                          data-name="Path 3343"
                          d="M17.9,9.76v.685a7.45,7.45,0,1,1-4.418-6.809"
                          transform="translate(0)"
                          fill="none"
                          stroke="#28c76f"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                        />
                        <path
                          id="Path_3344"
                          data-name="Path 3344"
                          d="M23.185,6l-7.45,7.458L13.5,11.223"
                          transform="translate(-5.285 -1.515)"
                          fill="none"
                          stroke="#28c76f"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                        />
                      </g>
                    </svg>
                    <span style="color: #28c76f">إيقاف الإلغاء</span>
                  </li>
                  <vs-divider class="m-0" />
                </vs-dropdown-item>
                <vs-dropdown-item
                  v-else-if="canBeResent"
                >
                  <li
                    @click="popupResend = true"
                    class="flex items-center py-4 px-4 cursor-pointer profile-drop"
                  >
                    <svg
                      class="mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="16.132"
                      height="13.465"
                      viewBox="0 0 16.132 13.465"
                    >
                      <defs>
                        <clipPath id="clip-path">
                          <rect
                            id="Rectangle_1485"
                            data-name="Rectangle 1485"
                            width="16.132"
                            height="13.465"
                            fill="none"
                          />
                        </clipPath>
                      </defs>
                      <g
                        id="Group_2327"
                        data-name="Group 2327"
                        transform="translate(0 0)"
                      >
                        <g
                          id="Group_2326"
                          data-name="Group 2326"
                          transform="translate(0 0)"
                          clip-path="url(#clip-path)"
                        >
                          <path
                            id="Path_3348"
                            data-name="Path 3348"
                            d="M15.794,5.507a.735.735,0,0,0,.021-.1V1.412a.749.749,0,0,0-1.5,0V3.674l-1.808-1.7A6.736,6.736,0,0,0,1.4,4.489a.748.748,0,0,0,1.411.5A5.247,5.247,0,0,1,9.494,1.8a5.324,5.324,0,0,1,1.975,1.251l1.709,1.607h-2.1a.749.749,0,0,0,0,1.5h3.991a.746.746,0,0,0,.292-.059c.006,0,.011-.01.019-.012a.74.74,0,0,0,.225-.158l.011-.006a.814.814,0,0,0,.06-.1.773.773,0,0,0,.086-.139.743.743,0,0,0,.035-.172"
                            transform="translate(0.317 0)"
                            fill="#6e6b7b"
                          />
                          <path
                            id="Path_3349"
                            data-name="Path 3349"
                            d="M13.963,6.636a.751.751,0,0,0-.955.457,5.239,5.239,0,0,1-8.66,1.939L2.637,7.425h2.1a.749.749,0,1,0,0-1.5H.748l-.01,0a.712.712,0,0,0-.207.042.586.586,0,0,0-.078.017.708.708,0,0,0-.1.065.737.737,0,0,0-.143.1L.2,6.164a.7.7,0,0,0-.057.091A.75.75,0,0,0,.056,6.4a.71.71,0,0,0-.033.168A.624.624,0,0,0,0,6.676v3.991a.749.749,0,1,0,1.5,0V8.406l1.809,1.7a6.744,6.744,0,0,0,9.525,0A6.792,6.792,0,0,0,14.42,7.592a.749.749,0,0,0-.457-.955"
                            transform="translate(0 1.388)"
                            fill="#6e6b7b"
                          />
                        </g>
                      </g>
                    </svg>
                    <span>{{ $t('resendOrder') }}</span>
                  </li>
                  <vs-divider class="m-0" />
                </vs-dropdown-item>
                <vs-dropdown-item
                  v-if="canBeResentWithNewOrder"
                >
                  <li
                    @click="popupResendWithNewOrder = true"
                    class="flex items-center py-4 px-4 cursor-pointer profile-drop" >
                    <svg
                      class="mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="16.132"
                      height="13.465"
                      viewBox="0 0 16.132 13.465"
                    >
                      <defs>
                        <clipPath id="clip-path">
                          <rect
                            id="Rectangle_1485"
                            data-name="Rectangle 1485"
                            width="16.132"
                            height="13.465"
                            fill="none"
                          />
                        </clipPath>
                      </defs>
                      <g
                        id="Group_2327"
                        data-name="Group 2327"
                        transform="translate(0 0)"
                      >
                        <g
                          id="Group_2326"
                          data-name="Group 2326"
                          transform="translate(0 0)"
                          clip-path="url(#clip-path)"
                        >
                          <path
                            id="Path_3348"
                            data-name="Path 3348"
                            d="M15.794,5.507a.735.735,0,0,0,.021-.1V1.412a.749.749,0,0,0-1.5,0V3.674l-1.808-1.7A6.736,6.736,0,0,0,1.4,4.489a.748.748,0,0,0,1.411.5A5.247,5.247,0,0,1,9.494,1.8a5.324,5.324,0,0,1,1.975,1.251l1.709,1.607h-2.1a.749.749,0,0,0,0,1.5h3.991a.746.746,0,0,0,.292-.059c.006,0,.011-.01.019-.012a.74.74,0,0,0,.225-.158l.011-.006a.814.814,0,0,0,.06-.1.773.773,0,0,0,.086-.139.743.743,0,0,0,.035-.172"
                            transform="translate(0.317 0)"
                            fill="#6e6b7b"
                          />
                          <path
                            id="Path_3349"
                            data-name="Path 3349"
                            d="M13.963,6.636a.751.751,0,0,0-.955.457,5.239,5.239,0,0,1-8.66,1.939L2.637,7.425h2.1a.749.749,0,1,0,0-1.5H.748l-.01,0a.712.712,0,0,0-.207.042.586.586,0,0,0-.078.017.708.708,0,0,0-.1.065.737.737,0,0,0-.143.1L.2,6.164a.7.7,0,0,0-.057.091A.75.75,0,0,0,.056,6.4a.71.71,0,0,0-.033.168A.624.624,0,0,0,0,6.676v3.991a.749.749,0,1,0,1.5,0V8.406l1.809,1.7a6.744,6.744,0,0,0,9.525,0A6.792,6.792,0,0,0,14.42,7.592a.749.749,0,0,0-.457-.955"
                            transform="translate(0 1.388)"
                            fill="#6e6b7b"
                          />
                        </g>
                      </g>
                    </svg>
                    <span>{{ $t('resendOrderWithNewOrder') }}</span>
                  </li>
                  <vs-divider class="m-0" />
                </vs-dropdown-item>
                <vs-dropdown-item
                  v-if="
                    detail_of_order.urgent_option && !detail_of_order.is_urgent
                  "
                >
                  <li
                    @click="urgentOrder"
                    class="flex items-center py-4 px-4 cursor-pointer profile-drop"
                  >
                    <svg
                      width="16"
                      height="16"
                      class="mr-2"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 14L8 11M11 14C12.3968 13.4687 13.7369 12.7987 15 12M11 14V19C11 19 14.03 18.45 15 17C16.08 15.38 15 12 15 12M8 11C8.53214 9.61943 9.2022 8.29607 10 7.05C11.1652 5.18699 12.7876 3.65305 14.713 2.5941C16.6384 1.53514 18.8027 0.986375 21 1C21 3.72 20.22 8.5 15 12M8 11H3C3 11 3.55 7.97 5 7C6.62 5.92 10 7 10 7M3.5 15.5C2 16.76 1.5 20.5 1.5 20.5C1.5 20.5 5.24 20 6.5 18.5C7.21 17.66 7.2 16.37 6.41 15.59C6.02131 15.219 5.50929 15.0046 4.97223 14.988C4.43516 14.9714 3.91088 15.1537 3.5 15.5Z"
                        stroke="#FF5730"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span style="color: #ff5730">طلب مستعجل</span>
                  </li>
                </vs-dropdown-item>
              </template>
            </ul>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- EDIT ORDER -->
        <button
          v-if="conditionEdit&&statusOfOrder.saved===detail_of_order.client_status "
          class="edit-btn mr-4"
          @click.stop="
            googleEventTrack(
              'الضغط على زر التعديل',
              'order_details',
              'edit_order_action'
            ),
              editData()
          "
        >
          <feather-icon
            class="mr-1 font-semibold"
            style="color: #31006f"
            icon="EditIcon"
            svgClasses="h-4 w-4"
          ></feather-icon>
          {{ $t("edit") }}
        </button>

        <!-- Add ticket -->
        <button class="edit-btn bg-white" @click="addNewTicket()">
          <div class="flex items-center" v-if="!loadingTicket">
            <feather-icon
              class="mr-1 font-semibold"
              style="color: #31006f"
              icon="PlusIcon"
              svgClasses="h-4 w-4"
            ></feather-icon>
            <span>إضافة تذكرة</span>
          </div>
          <spinner-color v-else />
        </button>
      </div>
    </div>
    <div class="line"></div>

    <!-- ROWS ORDER DETAIL -->
    <div v-if="loading" class="loaderSpinner"><spinner-color /></div>
    <div v-else>
      <div
        v-if="success"
        class="vx-row justify-between"
        style="padding-right: 1.3rem; padding-left: 1.3rem"
      >
        <div style="width: 78.518%">
          <!-- ROW 1 -->
          <div
            class="vx-row justify-between w-full mx-0"
            style="margin-bottom: 1.5rem"
          >
            <!-- ORDER DETAIL 1 -->
            <div class="order-detail">
              <h3 class="font-semibold mb-3 pl-2" style="font-size: 1rem">
                {{ $t("orderData") }} :
              </h3>
              <div class="order-detail-body">
                <div class="flex mb-2 justify-between text-center">
                  <div style="height: 72.5px">
                    <span
                      class="font-semibold mb-2"
                      style="display: inline-block"
                      >{{ $t("barcode") }} :</span
                    >
                    <span style="display: block" class="mb-2">
                      <img
                        style="width: 100px; height: 25px"
                        :src="detail_of_order.barcode"
                      />
                    </span>
                  </div>
                  <div>
                    <span
                      class="font-semibold mb-2"
                      style="display: inline-block"
                      >{{ $t("orderCode") }} :</span
                    >
                    <span class="order-status flex items-center justify-center">
                      {{ detail_of_order.code }}
                      <svg
                        @click="copyText('copyCode')"
                        class="ml-2 cursor-pointer"
                        id="Icon_ionic-ios-copy"
                        data-name="Icon ionic-ios-copy"
                        xmlns="http://www.w3.org/2000/svg"
                        width="9.521"
                        height="11.901"
                        viewBox="0 0 9.521 11.901"
                      >
                        <path
                          id="Path_1006"
                          data-name="Path 1006"
                          d="M23.881,3.584h2.231a.149.149,0,0,0,.149-.149h0a.692.692,0,0,0-.248-.528L24.1,1.316a.927.927,0,0,0-.511-.183h0a.183.183,0,0,0-.183.183v1.8A.475.475,0,0,0,23.881,3.584Z"
                          transform="translate(-16.74 -1.13)"
                          fill="#31006F"
                        />
                        <path
                          id="Path_1007"
                          data-name="Path 1007"
                          d="M14.166,3.109V1.125H10.918a.8.8,0,0,0-.793.793v8.331a.8.8,0,0,0,.793.793h5.951a.8.8,0,0,0,.793-.793V4.224h-2.38A1.117,1.117,0,0,1,14.166,3.109Z"
                          transform="translate(-8.141 -1.125)"
                          fill="#31006F"
                        />
                        <path
                          id="Path_1008"
                          data-name="Path 1008"
                          d="M5.789,13.857V5.625h-.5a.8.8,0,0,0-.793.793v8.728a.8.8,0,0,0,.793.793h6.347a.8.8,0,0,0,.793-.793v-.5H6.583A.8.8,0,0,1,5.789,13.857Z"
                          transform="translate(-4.5 -4.038)"
                          fill="#31006F"
                        />
                      </svg>
                      <input
                        type="hidden"
                        ref="copyCode"
                        :value="detail_of_order.code"
                      />
                    </span>
                  </div>
                  <div>
                    <span
                      class="font-semibold mb-2"
                      style="display: inline-block"
                      >{{ $t("statusOfOrder") }} :</span
                    >
                    <span class="order-status">{{
                      $t(returnOrderStatus(detail_of_order.client_status))
                    }}</span>
                  </div>
                </div>
                <div class="flex justify-between">
                  <div style="width: 50%">
                    <p class="mb-2">
                      {{ $t("maxDeliveryTime") }} :
                      <span class="font-semibold">{{
                        detail_of_order.max_delivery_days
                      }}</span>
                    </p>
                    <p class="mb-2">
                      {{ $t("invoiceNumber") }} :
                      <span class="font-semibold">{{
                        ifFound(detail_of_order.invoice_number)
                      }}</span>
                    </p>
                    <vx-tooltip
                      :text="detail_of_order.notes"
                      position="bottom"
                      delay=".2s"
                    >
                      <p class="mb-2 flex">
                        {{ $t("notesOrder") }} :
                        <span class="trim-note font-semibold">{{
                          ifFound(detail_of_order.notes)
                        }}</span>
                      </p>
                    </vx-tooltip>
                  </div>
                  <div style="width: 50%">
                    <vx-tooltip
                      :text="detail_of_order.order_summary"
                      position="bottom"
                      delay=".2s"
                    >
                      <p class="mb-2 flex">
                        {{ $t("contentOrder") }} :
                        <span class="trim-note font-semibold">
                          {{ detail_of_order.order_summary }}</span
                        >
                      </p>
                    </vx-tooltip>
                    <p class="mb-2">
                      {{ $t("piecesCount") }} :
                      <span class="font-semibold">{{
                        detail_of_order.pieces_count
                      }}</span>
                    </p>
                    <p class="mb-2">
                      {{ $t("deliveryTime") }} :
                      <span class="font-semibold">{{
                        detail_of_order.delivery_date
                      }}</span>
                    </p>
                    <p>
                      {{ $t("priceOfExtraKilo") }} :
                      <span class="font-semibold">{{
                        detail_of_order.kilo_price
                      }}</span>
                    </p>
                  </div>
                </div>
                <p>
                  {{ $t("willOrderBe") }}
                  <span class="font-semibold return-status">{{
                    detail_of_order.carry_from_reciever
                  }}</span>
                </p>
                <p>
                  {{ $t("canOpen") }}
                  <span class="font-semibold return-status">{{
                    detail_of_order.can_open == 1 ? $t("Yes") : $t("No")
                  }}</span>
                </p> 
                 <p>
                  {{ $t("isMeasurable") }}
                  <span class="font-semibold return-status">{{
                    detail_of_order.is_measurable == 1 ? $t("Yes") : $t("No")
                  }}</span>
                </p> 
                <p>
                  {{ $t("isFragile") }}
                  <span class="font-semibold return-status">{{
                    detail_of_order.is_fragile == 1 ? $t("Yes") : $t("No")
                  }}</span>
                </p> 
                <p>
                  {{ $t("ShippingOnSender") }}
                  <span class="font-semibold return-status">{{
                    detail_of_order.shipping_payer == 1 ? $t("No") : $t("Yes")
                  }}</span>
                </p> 
                <p>
                  {{ $t("ExtraCostOnSender") }}
                  <span class="font-semibold return-status">{{
                    detail_of_order.extra_cost_payer == 1 ? $t("No") : $t("Yes")

                  }}</span>
                </p>
                <p v-if="detail_of_order.is_bank_payment">
                  {{ $t("IsbankPaymentCommissionPayerSender") }}
                  <span class="font-semibold return-status">{{
                    detail_of_order.payment_commission_payer == 2 ? $t("Yes") : $t("No")
                  }}</span>
                </p>
                <p>
                  {{ $t("Aceept20Plus5Dinar") }}
                  <span class="font-semibold return-status">{{
                    detail_of_order.accept_20_plus_5_dinar == 0 ? $t("No") : $t("Yes")
                  }}</span>
                </p>  
              </div>
            </div>
            <!-- ORDER DETAIL 2 -->
            <div class="order-detail">
              <h3 class="font-semibold mb-3 pl-2" style="font-size: 1rem">
                {{ $t("senderReceiverData") }} :
              </h3>
              <div class="order-detail-body" style="padding-bottom: 1.9375rem">
                <div class="flex mb-2 justify-between">
                  <div>
                    <p>
                      {{ $t("mainSender") }} :
                      <span class="font-semibold">{{
                        detail_of_order.client_name
                      }}</span>
                    </p>
                  </div>
                  <div>
                    <p>
                      {{ $t("senderNumber") }} :
                      <span class="font-semibold">{{
                        ifFound(detail_of_order.api_followup_phone)
                      }}</span>
                    </p>
                  </div>
                </div>
                <p class="mb-2">
                  {{ $t("sender") }} :
                  <span class="font-semibold">{{
                    ifFound(detail_of_order.second_client)
                  }}</span>
                </p>
                <p class="mb-2">
                  {{ $t("receiver") }} :
                  <span>{{ ifFound(detail_of_order.receiver) }}</span>
                </p>
                <p class="mb-2">
                  {{ $t("receiverNumber") }} :
                  <span class="font-semibold number-phone"
                    >{{ ifFound(detail_of_order.phone1) }} -
                    {{ ifFound(detail_of_order.phone2) }}</span
                  >
                </p>
                <div class="flex mb-2 justify-between">
                  <div>
                    <p>
                      {{ $t("government") }} :
                      <span class="font-semibold">{{
                        detail_of_order.government_name
                      }}</span>
                    </p>
                  </div>
                  <div>
                    <p>
                      {{ $t("area") }} :
                      <span class="font-semibold">{{
                        detail_of_order.area
                      }}</span>
                    </p>
                  </div>
                </div>
                <vx-tooltip
                  :text="detail_of_order.address"
                  position="bottom"
                  delay=".2s"
                >
                  <p class="mb-1 flex">
                    {{ $t("address") }} :
                    <span class="trim-note font-semibold">{{
                      detail_of_order.address
                    }}</span>
                    <i class="ml-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                      >
                        <g
                          id="Group_776"
                          data-name="Group 776"
                          transform="translate(-376 -393)"
                        >
                          <circle
                            id="Ellipse_395"
                            data-name="Ellipse 395"
                            cx="10"
                            cy="10"
                            r="10"
                            transform="translate(376 393)"
                            fill="rgba(49,0,111,0.1)"
                          />
                          <path
                            id="Icon_material-location-on"
                            data-name="Icon material-location-on"
                            d="M11.605,3A4.1,4.1,0,0,0,7.5,7.105c0,3.079,4.105,7.624,4.105,7.624s4.105-4.545,4.105-7.624A4.1,4.1,0,0,0,11.605,3Zm0,5.572a1.466,1.466,0,1,1,1.466-1.466A1.467,1.467,0,0,1,11.605,8.572Z"
                            transform="translate(374.5 394)"
                            fill="#31006f"
                          />
                        </g>
                      </svg>
                    </i>
                  </p>
                </vx-tooltip>
              </div>
            </div>
          </div>

          <!-- ROW 2 -->
          <div
            class="vx-row justify-between w-full mx-0"
            style="margin-bottom: 1.5rem"
          >
            <!-- ORDER DETAIL 3 -->
            <div class="order-detail-body order-detail">
              <div class="flex mb-2 justify-between">
                <div>
                  <p class="mb-2">
                    {{ $t("contentReturn") }} :
                    <span class="font-semibold">{{
                      ifFound(detail_of_order.return_summary)
                    }}</span>
                  </p>
                  <template v-if="$acl.not.check('isPublicCompany')">
                    <p class="mb-2">
                      {{ $t("receivingBranch") }} :
                      <span class="font-semibold">{{
                        ifFound(detail_of_order.received_branch_name)
                      }}</span>
                    </p>
                    <p class="mb-2">
                      {{ $t("currentBranch") }} :
                      <span class="font-semibold">{{
                        ifFound(detail_of_order.current_branch_name)
                      }}</span>
                    </p>
                    <p class="mb-2">
                      {{ $t("executingBranch") }} :
                      <span class="font-semibold">{{
                        ifFound(detail_of_order.exec_branch_name)
                      }}</span>
                    </p>
                    <p>
                      {{ $t("captain") }} :
                      <span class="font-semibold">{{
                        ifFound(detail_of_order.captain_name)
                      }}</span>
                    </p>
                  </template>
                </div>
                <div>
                  <p class="mb-2">
                    {{ $t("returnCost") }} :
                    <span class="font-semibold"
                      >{{
                        detail_of_order.return_amount
                          ? detail_of_order.return_amount
                          : 0
                      }}
                      {{ $t("pounds") }}</span
                    >
                  </p>
                  <template
                    v-if="
                      $acl.not.check('isPublicCompany') ||
                      companySettings.show_branch_phone
                    "
                  >
                    <p class="mb-2">
                      ارقام الفرع :
                      <span class="font-semibold"
                        >{{ ifFound(detail_of_order.received_branch_phone1) }}
                      </span>
                      <span
                        v-if="
                          detail_of_order.received_branch_phone2 ||
                          detail_of_order.received_branch_tel
                        "
                        class="cursor-pointer more-mobile"
                        ref="more-mobile1"
                        @click="showBranchNumber1 = !showBranchNumber1"
                        >أرقام اضافية
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="4"
                          height="6.997"
                          viewBox="0 0 4 6.997"
                          class="ml-1"
                        >
                          <path
                            id="Icon_ionic-ios-arrow-back"
                            data-name="Icon ionic-ios-arrow-back"
                            d="M12.456,9.691,15.1,7.046A.5.5,0,0,0,14.4,6.34l-3,3a.5.5,0,0,0-.015.689l3.012,3.018a.5.5,0,1,0,.708-.706Z"
                            transform="translate(-11.251 -6.194)"
                            fill="#31006f"
                          /></svg>
                    </span>
                    </p>
                    <div v-if="showBranchNumber1" style="position: relative">
                      <span
                        class="font-semibold more-mobile-result"
                        ref="received-branch-mobile"
                        ><h4>أرقام الفرع</h4>
                        {{ ifFound(detail_of_order.received_branch_phone1) }} -
                        {{ ifFound(detail_of_order.received_branch_phone2) }} -
                        {{ ifFound(detail_of_order.received_branch_tel) }}</span
                      >
                    </div>
                    <p class="mb-2">
                      ارقام الفرع :
                      <span class="font-semibold"
                        >{{ ifFound(detail_of_order.current_branch_phone1) }}
                      </span>
                      <span
                        v-if="
                          detail_of_order.current_branch_phone2 ||
                          detail_of_order.current_branch_tel
                        "
                        class="cursor-pointer more-mobile"
                        ref="more-mobile2"
                        @click="showBranchNumber2 = !showBranchNumber2"
                        >أرقام اضافية
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="4"
                          height="6.997"
                          viewBox="0 0 4 6.997"
                          class="ml-1"
                        >
                          <path
                            id="Icon_ionic-ios-arrow-back"
                            data-name="Icon ionic-ios-arrow-back"
                            d="M12.456,9.691,15.1,7.046A.5.5,0,0,0,14.4,6.34l-3,3a.5.5,0,0,0-.015.689l3.012,3.018a.5.5,0,1,0,.708-.706Z"
                            transform="translate(-11.251 -6.194)"
                            fill="#31006f"
                          /></svg>
                      </span>
                    </p>
                    <div v-if="showBranchNumber2" style="position: relative">
                      <span
                        class="font-semibold more-mobile-result"
                        ref="current-branch-mobile"
                        ><h4>أرقام الفرع</h4>
                        {{ ifFound(detail_of_order.current_branch_phone1) }} -
                        {{ ifFound(detail_of_order.current_branch_phone2) }} -
                        {{ ifFound(detail_of_order.current_branch_tel) }}</span>
                      >
                    </div>
                    <p class="mb-2">
                      ارقام الفرع :
                      <span class="font-semibold"
                        >{{ ifFound(detail_of_order.exec_branch_phone1) }}
                      </span>
                      <span
                        v-if="
                          detail_of_order.exec_branch_phone2 ||
                          detail_of_order.exec_branch_tel
                        "
                        class="cursor-pointer more-mobile"
                        ref="more-mobile3"
                        @click="showBranchNumber3 = !showBranchNumber3"
                        >أرقام اضافية
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="4"
                          height="6.997"
                          viewBox="0 0 4 6.997"
                          class="ml-1"
                        >
                          <path
                            id="Icon_ionic-ios-arrow-back"
                            data-name="Icon ionic-ios-arrow-back"
                            d="M12.456,9.691,15.1,7.046A.5.5,0,0,0,14.4,6.34l-3,3a.5.5,0,0,0-.015.689l3.012,3.018a.5.5,0,1,0,.708-.706Z"
                            transform="translate(-11.251 -6.194)"
                            fill="#31006f"
                          /></svg>
                      </span>
                    </p>
                    <div v-if="showBranchNumber3" style="position: relative">
                      <span
                        class="font-semibold more-mobile-result"
                        ref="exec-branch-mobile"
                        ><h4>أرقام الفرع</h4>
                        {{ ifFound(detail_of_order.exec_branch_phone1) }} -
                        {{ ifFound(detail_of_order.exec_branch_phone2) }} -
                        {{ ifFound(detail_of_order.exec_branch_tel) }}</span
                      >
                    </div>
                    <p>
                      {{ $t("captainNumber") }} :
                      <span class="font-semibold"
                        >{{ ifFound(detail_of_order.captain_phone1) }} -
                        {{ ifFound(detail_of_order.captain_phone2) }}</span
                      >
                    </p>
                  </template>
                </div>
              </div>
              <p class="mb-2">
                <span class="font-semibold"></span>
              </p>
            </div>
            <!-- ORDER DETAIL 4 -->
            <div class="order-detail-body order-detail">
              <div class="flex mb-2 justify-between">
                <div>
                  <p class="mb-2">
                    {{ $t("deliveryCost") }} :
                    <span class="font-semibold">{{
                      detail_of_order.delivery_cost
                    }}</span>
                  </p>
                  <p class="mb-2">
                    {{ $t("extraCost") }} :
                    <span class="font-semibold"
                      >{{
                        detail_of_order.extra_cost
                          ? detail_of_order.extra_cost
                          : 0
                      }}
                      {{ $t("pounds") }}</span
                    >
                  </p>
                  <p v-if="detail_of_order.is_bank_payment">
                    {{ $t("bankPaymentCommissionValue") }} :
                    <span class="font-semibold">{{
                      detail_of_order.payment_commission
                        ? detail_of_order.payment_commission
                        : 0
                    }}
                      {{ $t("pounds") }}</span>
                  </p>
                </div>
                <div>
                  <p class="mb-2">
                    {{ $t("totalShippingPrice") }} :
                    <span class="order-status total-cost"
                      >{{
                        detail_of_order.shipment_cost
                          ? detail_of_order.shipment_cost
                          : 0
                      }}
                      {{ $t("pounds") }}</span
                    >
                  </p>
                  <p>
                    {{ $t("reason") }} :
                    <span class="font-semibold"
                      >{{
                        detail_of_order.extra_cost_reason
                          ? detail_of_order.extra_cost_reason
                          : 0
                      }}
                      {{ $t("pounds") }}</span
                    >
                  </p>
                </div>
              </div>
              <p class="mb-2">
                <span>{{ $t("clientPaymentAmount") }} :</span>
                <span
                  class="return-status"
                  style="font-size: 0.75rem; margin-right: 0.5rem"
                  >{{
                    detail_of_order.client_payment
                      ? detail_of_order.client_payment
                      : 0
                  }}
                  {{ $t("pounds") }}</span
                >
              </p>
              <div class="flex mb-2 justify-between">
                <div>
                  <p class="mb-2">
                    {{ $t("packagingCost") }} :
                    <span class="font-semibold"
                      >{{
                        detail_of_order.packaging_service
                          ? detail_of_order.packaging_service
                          : 0
                      }}
                      {{ $t("pounds") }}</span
                    >
                  </p>
                  <p>
                    {{ $t("storageCost") }} :
                    <span class="font-semibold"
                      >{{
                        detail_of_order.stock_service
                          ? detail_of_order.stock_service
                          : 0
                      }}
                      {{ $t("pounds") }}</span
                    >
                  </p>
                </div>
                <div>
                  <p class="mb-2">
                    {{ $t("insuranceCost") }} :
                    <span class="font-semibold"
                      >{{
                        detail_of_order.protection_service
                          ? detail_of_order.protection_service
                          : 0
                      }}
                      {{ $t("pounds") }}</span
                    >
                  </p>
                  <p>
                    {{ $t("collectionCost") }} :
                    <span class="font-semibold"
                      >{{
                        detail_of_order.client_received_amount
                          ? detail_of_order.client_received_amount
                          : 0
                      }}
                      {{ $t("pounds") }}</span
                    >
                  </p>
                </div>
              </div>
              <div
                class="flex justify-between text-center margin-bottom: 0.3125rem;"
              >
                <div>
                  <span class="font-semibold" style="display: inline-block"
                    >$
                    {{
                      detail_of_order.amount_to_be_collected
                        ? detail_of_order.amount_to_be_collected
                        : 0
                    }}
                    {{ $t("pounds") }}</span
                  >
                  <span style="display: block">{{
                    $t("collectedAmount")
                  }}</span>
                </div>
                <div>
                  <span class="font-semibold" style="display: inline-block"
                    >$
                    {{
                      detail_of_order.received_amount
                        ? detail_of_order.received_amount
                        : 0
                    }}
                    {{ $t("pounds") }}</span
                  >
                  <span style="display: block">{{
                    $t("amountAlreadyCollected")
                  }}</span>
                </div>
                <div>
                  <span
                    class="font-semibold"
                    style="display: inline-block; color: #28c76f"
                    >$
                    {{
                      detail_of_order.cash_amount
                        ? detail_of_order.cash_amount
                        : 0
                    }}
                    {{ $t("pounds") }}</span
                  >
                  <span style="display: block">{{ $t("amountSupplied") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ROW 3 -->
        <!-- return_reason -->
        <div style="width: 20.314%; padding-top: 2rem">
          <template
            v-if="
              detail_of_order.order_products.length &&
              typeof this.detail_of_order.order_products == 'object'
            "
          >
            <div class="title-order-times">المنتجات المضافة</div>
            <div class="order-times mb-4">
              <div
                v-for="(product, index) in detail_of_order.order_products"
                :key="index"
              >
                <div class="card-date">
                  <div
                    class="flex justify-between items-center font-semibold text-primary"
                  >
                    <div>
                      <span
                        >{{
                          product.client_product
                            ? product.client_product.name
                            : product.name
                        }}
                      </span>
                      <span class="font-semibold text-primary block font-12"
                        ><small>{{
                          product.client_product
                            ? product.client_product.sku
                            : product.sku
                        }}</small></span
                      >
                    </div>
                    <span class="font-semibold text-primary"
                      >الكمية
                      <span class="qnt-product">{{
                        product.quantity
                      }}</span></span
                    >
                  </div>
                </div>
                <div class="line-card"></div>
              </div>
            </div>
          </template>
          <div class="title-order-times">{{ $t("allDatesOfOreder") }}</div>
          <div class="order-times">
            <div class="card-date">
              <i
                class="icon-order-times"
                :style="
                  detail_of_order.created_at
                    ? { 'background-color': '#28c76f17' }
                    : ''
                "
              >
                <svg
                  v-if="
                    detail_of_order.created_at != null &&
                    detail_of_order.created_at != ''
                  "
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.298"
                  height="12.298"
                  viewBox="0 0 12.298 12.298"
                >
                  <path
                    id="Icon_awesome-check-circle"
                    data-name="Icon awesome-check-circle"
                    d="M12.86,6.711A6.149,6.149,0,1,1,6.711.562,6.149,6.149,0,0,1,12.86,6.711ZM6,9.967l4.562-4.562a.4.4,0,0,0,0-.561L10,4.283a.4.4,0,0,0-.561,0L5.72,8,3.983,6.267a.4.4,0,0,0-.561,0l-.561.561a.4.4,0,0,0,0,.561L5.439,9.967A.4.4,0,0,0,6,9.967Z"
                    transform="translate(-0.563 -0.563)"
                    fill="#21b463"
                  />
                </svg>
                <feather-icon
                  v-else
                  icon="PackageIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </i>
              <div style="overflow: hidden">
                <span style="display: inline-block; margin-left: 0.25rem"
                  >{{ $t("registration") }}:
                </span>
                <span class="font-semibold">{{
                  detail_of_order.created_at
                }}</span>
              </div>
            </div>
            <div class="line-card"></div>
            <!-- تم إخفاء تاريخ الإرسال (detail_of_order.sent_at) بناءً على الطلب -->
            <div class="card-date" v-if="false">
              <i
                class="icon-order-times"
                :style="
                  detail_of_order.sent_at
                    ? { 'background-color': '#28c76f17' }
                    : ''
                "
              >
                <svg
                  v-if="
                    detail_of_order.sent_at != null &&
                    detail_of_order.sent_at != ''
                  "
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.298"
                  height="12.298"
                  viewBox="0 0 12.298 12.298"
                >
                  <path
                    id="Icon_awesome-check-circle"
                    data-name="Icon awesome-check-circle"
                    d="M12.86,6.711A6.149,6.149,0,1,1,6.711.562,6.149,6.149,0,0,1,12.86,6.711ZM6,9.967l4.562-4.562a.4.4,0,0,0,0-.561L10,4.283a.4.4,0,0,0-.561,0L5.72,8,3.983,6.267a.4.4,0,0,0-.561,0l-.561.561a.4.4,0,0,0,0,.561L5.439,9.967A.4.4,0,0,0,6,9.967Z"
                    transform="translate(-0.563 -0.563)"
                    fill="#21b463"
                  />
                </svg>
                <feather-icon
                  v-else
                  icon="PackageIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </i>
              <div style="overflow: hidden">
                <span style="display: inline-block; margin-left: 0.25rem"
                  >{{ $t("sending") }}:
                </span>
                <span class="font-semibold">{{ detail_of_order.sent_at }}</span>
              </div>
            </div>
            <div class="line-card"></div>
            <div class="card-date">
              <i
                class="icon-order-times"
                :style="
                  detail_of_order.delivery_date
                    ? { 'background-color': '#28c76f17' }
                    : ''
                "
              >
                <svg
                  v-if="
                    detail_of_order.delivery_date != null &&
                    detail_of_order.delivery_date != ''
                  "
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.298"
                  height="12.298"
                  viewBox="0 0 12.298 12.298"
                >
                  <path
                    id="Icon_awesome-check-circle"
                    data-name="Icon awesome-check-circle"
                    d="M12.86,6.711A6.149,6.149,0,1,1,6.711.562,6.149,6.149,0,0,1,12.86,6.711ZM6,9.967l4.562-4.562a.4.4,0,0,0,0-.561L10,4.283a.4.4,0,0,0-.561,0L5.72,8,3.983,6.267a.4.4,0,0,0-.561,0l-.561.561a.4.4,0,0,0,0,.561L5.439,9.967A.4.4,0,0,0,6,9.967Z"
                    transform="translate(-0.563 -0.563)"
                    fill="#21b463"
                  />
                </svg>
                <feather-icon
                  v-else
                  icon="PackageIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </i>
              <div style="overflow: hidden">
                <span style="display: inline-block; margin-left: 0.25rem"
                  >التسليم:
                </span>
                <span class="font-semibold">{{
                  detail_of_order.delivery_date
                }}</span>
              </div>
            </div>
            <div class="line-card"></div>
            <div class="card-date">
              <!-- length -->
              <i
                class="icon-order-times"
                :style="
                  delay_log.length != 0
                    ? { 'background-color': '#28c76f17' }
                    : ''
                "
              >
                <svg
                  v-if="delay_log.length != 0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.298"
                  height="12.298"
                  viewBox="0 0 12.298 12.298"
                >
                  <path
                    id="Icon_awesome-check-circle"
                    data-name="Icon awesome-check-circle"
                    d="M12.86,6.711A6.149,6.149,0,1,1,6.711.562,6.149,6.149,0,0,1,12.86,6.711ZM6,9.967l4.562-4.562a.4.4,0,0,0,0-.561L10,4.283a.4.4,0,0,0-.561,0L5.72,8,3.983,6.267a.4.4,0,0,0-.561,0l-.561.561a.4.4,0,0,0,0,.561L5.439,9.967A.4.4,0,0,0,6,9.967Z"
                    transform="translate(-0.563 -0.563)"
                    fill="#21b463"
                  />
                </svg>
                <feather-icon
                  v-else
                  icon="PackageIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </i>
              <div style="overflow: hidden" v-if="delay_log.length != 0">
                <span style="display: inline-block; margin-left: 0.25rem"
                  >{{ $t("postponement") }}:
                </span>
                <span class="font-semibold">{{
                  delay_log[0].log_created_at
                }}</span>
                <span class="action-delay" @click="showReason(1)">
                  <span class="delay_reason">{{ $t("reason") }}</span>
                  <span class="delay_reason_icon" id="delay_reason_icon1">
                    <svg
                      data-v-7f6390f4=""
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-left h-4 w-4"
                    >
                      <polyline
                        data-v-7f6390f4=""
                        points="15 18 9 12 15 6"
                      ></polyline>
                    </svg>
                  </span>
                </span>
                <div class="delay-result" id="delay-result1">
                  <div v-for="(log, index) in delay_log" :key="index">
                    <i>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9.38"
                        height="10.002"
                        viewBox="0 0 9.38 10.002"
                      >
                        <g
                          id="Icon_feather-arrow-left"
                          data-name="Icon feather-arrow-left"
                          transform="translate(-6.75 -6.439)"
                        >
                          <path
                            id="Path_1680"
                            data-name="Path 1680"
                            d="M15.38,18H7.5"
                            transform="translate(0 -6.56)"
                            fill="none"
                            stroke="#31006F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          />
                          <path
                            id="Path_1681"
                            data-name="Path 1681"
                            d="M11.44,15.38,7.5,11.44,11.44,7.5"
                            fill="none"
                            stroke="#31006F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          />
                        </g>
                      </svg>
                    </i>
                    <span style="font-size: 12px; color: #6e6b7b">
                      تاريخ التأجيل : {{ log.log_created_at }}
                    </span>
                    <input
                      :ref="'copyText' + (index + 1)"
                      type="hidden"
                      :value="log.reason"
                    />
                    <vx-tooltip
                      :text="log.reason"
                      position="bottom"
                      delay=".2s"
                    >
                      <p class="mb-2cursor-pointer flex items-center">
                        <span class="delay_reason ml-0">{{ $t("reason") }}</span
                        >:
                        <span
                          style="
                            font-size: 12px;
                            color: #212121;
                            font-weight: bold;
                          "
                          class="trim-note mr-2"
                        >
                          {{ log.reason }}
                        </span>
                        <span @click="copyText('copyText' + (index + 1))">
                          <svg
                            id="Icon_ionic-ios-copy"
                            data-name="Icon ionic-ios-copy"
                            xmlns="http://www.w3.org/2000/svg"
                            width="9.521"
                            height="11.901"
                            viewBox="0 0 9.521 11.901"
                          >
                            <path
                              id="Path_1006"
                              data-name="Path 1006"
                              d="M23.881,3.584h2.231a.149.149,0,0,0,.149-.149h0a.692.692,0,0,0-.248-.528L24.1,1.316a.927.927,0,0,0-.511-.183h0a.183.183,0,0,0-.183.183v1.8A.475.475,0,0,0,23.881,3.584Z"
                              transform="translate(-16.74 -1.13)"
                              fill="#6e6b7b"
                            />
                            <path
                              id="Path_1007"
                              data-name="Path 1007"
                              d="M14.166,3.109V1.125H10.918a.8.8,0,0,0-.793.793v8.331a.8.8,0,0,0,.793.793h5.951a.8.8,0,0,0,.793-.793V4.224h-2.38A1.117,1.117,0,0,1,14.166,3.109Z"
                              transform="translate(-8.141 -1.125)"
                              fill="#6e6b7b"
                            />
                            <path
                              id="Path_1008"
                              data-name="Path 1008"
                              d="M5.789,13.857V5.625h-.5a.8.8,0,0,0-.793.793v8.728a.8.8,0,0,0,.793.793h6.347a.8.8,0,0,0,.793-.793v-.5H6.583A.8.8,0,0,1,5.789,13.857Z"
                              transform="translate(-4.5 -4.038)"
                              fill="#6e6b7b"
                            />
                          </svg>
                        </span>
                      </p>
                    </vx-tooltip>
                  </div>
                  <vx-tooltip
                    :text="detail_of_order.delay_reason_note"
                    position="bottom"
                    delay=".2s"
                  >
                    <p class="cursor-pointer flex items-center">
                      <span class="delay_reason ml-0">ملاحظات</span>:
                      <span
                        style="
                          font-size: 12px;
                          color: #212121;
                          font-weight: bold;
                        "
                        class="trim-note mr-2"
                      >
                        {{ detail_of_order.delay_reason_note }}
                      </span>
                    </p>
                  </vx-tooltip>
                </div>
              </div>
              <div style="overflow: hidden" v-else>
                <span style="display: inline-block; margin-left: 0.25rem"
                  >{{ $t("postponement") }}:
                </span>
              </div>
            </div>
            <div class="line-card"></div>
            <div class="card-date">
              <i
                class="icon-order-times"
                :style="
                  detail_of_order.execution_date
                    ? { 'background-color': '#28c76f17' }
                    : ''
                "
              >
                <svg
                  v-if="
                    detail_of_order.execution_date != null &&
                    detail_of_order.execution_date != ''
                  "
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.298"
                  height="12.298"
                  viewBox="0 0 12.298 12.298"
                >
                  <path
                    id="Icon_awesome-check-circle"
                    data-name="Icon awesome-check-circle"
                    d="M12.86,6.711A6.149,6.149,0,1,1,6.711.562,6.149,6.149,0,0,1,12.86,6.711ZM6,9.967l4.562-4.562a.4.4,0,0,0,0-.561L10,4.283a.4.4,0,0,0-.561,0L5.72,8,3.983,6.267a.4.4,0,0,0-.561,0l-.561.561a.4.4,0,0,0,0,.561L5.439,9.967A.4.4,0,0,0,6,9.967Z"
                    transform="translate(-0.563 -0.563)"
                    fill="#21b463"
                  />
                </svg>
                <feather-icon
                  v-else
                  icon="PackageIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </i>
              <div style="overflow: hidden">
                <span style="display: inline-block; margin-left: 0.25rem"
                  >{{ $t("implementation") }}:
                </span>
                <span class="font-semibold">{{
                  detail_of_order.execution_date
                }}</span>
                <span
                  class="action-delay"
                  @click="showReason(2)"
                  v-if="
                    detail_of_order.return_reason != null &&
                    detail_of_order.return_reason != ''
                  "
                >
                  <span class="delay_reason">{{ $t("reason") }}</span>
                  <span class="delay_reason_icon" id="delay_reason_icon2">
                    <svg
                      data-v-7f6390f4=""
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-left h-4 w-4"
                    >
                      <polyline
                        data-v-7f6390f4=""
                        points="15 18 9 12 15 6"
                      ></polyline>
                    </svg>
                  </span>
                </span>
                <div class="delay-result" id="delay-result2">
                  <div>
                    <i>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9.38"
                        height="10.002"
                        viewBox="0 0 9.38 10.002"
                      >
                        <g
                          id="Icon_feather-arrow-left"
                          data-name="Icon feather-arrow-left"
                          transform="translate(-6.75 -6.439)"
                        >
                          <path
                            id="Path_1680"
                            data-name="Path 1680"
                            d="M15.38,18H7.5"
                            transform="translate(0 -6.56)"
                            fill="none"
                            stroke="#31006F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          />
                          <path
                            id="Path_1681"
                            data-name="Path 1681"
                            d="M11.44,15.38,7.5,11.44,11.44,7.5"
                            fill="none"
                            stroke="#31006F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          />
                        </g>
                      </svg>
                    </i>
                    <span style="font-size: 12px; color: #6e6b7b">
                      تاريخ التنفيذ : {{ detail_of_order.execution_date }}
                    </span>
                    <vx-tooltip
                      :text="detail_of_order.return_reason"
                      position="bottom"
                      delay=".2s"
                    >
                      <p class="cursor-pointer flex items-center">
                        <span class="delay_reason ml-0">{{ $t("reason") }}</span
                        >:
                        <span
                          style="
                            font-size: 12px;
                            color: #212121;
                            font-weight: bold;
                          "
                          class="trim-note"
                          >{{ detail_of_order.return_reason }}</span
                        >
                      </p>
                    </vx-tooltip>
                    <vx-tooltip
                      :text="detail_of_order.return_reason_note"
                      position="bottom"
                      delay=".2s"
                    >
                      <p class="cursor-pointer flex items-center">
                        <span class="delay_reason ml-0">ملاحظات</span>:
                        <span
                          style="
                            font-size: 12px;
                            color: #212121;
                            font-weight: bold;
                          "
                          class="trim-note"
                          >{{ detail_of_order.return_reason_note }}</span
                        >
                      </p>
                    </vx-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div class="line-card"></div>
            <div class="card-date">
              <i
                class="icon-order-times"
                :style="
                  detail_of_order.supplied_date
                    ? { 'background-color': '#28c76f17' }
                    : ''
                "
              >
                <svg
                  v-if="
                    detail_of_order.supplied_date != null &&
                    detail_of_order.supplied_date != ''
                  "
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.298"
                  height="12.298"
                  viewBox="0 0 12.298 12.298"
                >
                  <path
                    id="Icon_awesome-check-circle"
                    data-name="Icon awesome-check-circle"
                    d="M12.86,6.711A6.149,6.149,0,1,1,6.711.562,6.149,6.149,0,0,1,12.86,6.711ZM6,9.967l4.562-4.562a.4.4,0,0,0,0-.561L10,4.283a.4.4,0,0,0-.561,0L5.72,8,3.983,6.267a.4.4,0,0,0-.561,0l-.561.561a.4.4,0,0,0,0,.561L5.439,9.967A.4.4,0,0,0,6,9.967Z"
                    transform="translate(-0.563 -0.563)"
                    fill="#21b463"
                  />
                </svg>
                <feather-icon
                  v-else
                  icon="PackageIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </i>
              <div style="overflow: hidden">
                <span style="display: inline-block; margin-left: 0.25rem"
                  >{{ $t("supply") }}:
                </span>
                <span class="font-semibold">{{
                  detail_of_order.supplied_date
                }}</span>
              </div>
            </div>
            <div class="line-card"></div>
            <div class="card-date">
              <i
                class="icon-order-times"
                :style="
                  detail_of_order.return_to_sender_date
                    ? { 'background-color': '#28c76f17' }
                    : ''
                "
              >
                <svg
                  v-if="
                    detail_of_order.return_to_sender_date != null &&
                    detail_of_order.return_to_sender_date != ''
                  "
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.298"
                  height="12.298"
                  viewBox="0 0 12.298 12.298"
                >
                  <path
                    id="Icon_awesome-check-circle"
                    data-name="Icon awesome-check-circle"
                    d="M12.86,6.711A6.149,6.149,0,1,1,6.711.562,6.149,6.149,0,0,1,12.86,6.711ZM6,9.967l4.562-4.562a.4.4,0,0,0,0-.561L10,4.283a.4.4,0,0,0-.561,0L5.72,8,3.983,6.267a.4.4,0,0,0-.561,0l-.561.561a.4.4,0,0,0,0,.561L5.439,9.967A.4.4,0,0,0,6,9.967Z"
                    transform="translate(-0.563 -0.563)"
                    fill="#21b463"
                  />
                </svg>
                <feather-icon
                  v-else
                  icon="PackageIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </i>
              <div style="overflow: hidden">
                <span style="display: inline-block; margin-left: 0.25rem"
                  >{{ $t("returnOnSender") }}:
                </span>
                <span class="font-semibold">{{
                  detail_of_order.return_to_sender_date
                }}</span>
              </div>
            </div>
            <div class="line-card"></div>
            <div
              class="card-date"
              v-if="detail_of_order.client_rate_digit != null"
            >
              <i class="icon-order-times" style="background-color: #28c76f17">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.298"
                  height="12.298"
                  viewBox="0 0 12.298 12.298"
                >
                  <path
                    id="Icon_awesome-check-circle"
                    data-name="Icon awesome-check-circle"
                    d="M12.86,6.711A6.149,6.149,0,1,1,6.711.562,6.149,6.149,0,0,1,12.86,6.711ZM6,9.967l4.562-4.562a.4.4,0,0,0,0-.561L10,4.283a.4.4,0,0,0-.561,0L5.72,8,3.983,6.267a.4.4,0,0,0-.561,0l-.561.561a.4.4,0,0,0,0,.561L5.439,9.967A.4.4,0,0,0,6,9.967Z"
                    transform="translate(-0.563 -0.563)"
                    fill="#21b463"
                  />
                </svg>
              </i>
              <div style="overflow: hidden">
                <span style="display: inline-block; margin-left: 0.25rem"
                  >مستوي الخدمة:
                </span>
                <span class="font-semibold">{{ clientRate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <vs-alert color="danger" icon="new_releases">
          <span>{{
            err_msg ? err_msg : "رقم الكود خاطئ, برجاء المحاولة مرة اخري"
          }}</span>
        </vs-alert>
      </div>
    </div>

    <!-- Popup Confirmation -->
    <vs-popup
      class="holamundo"
      :title="$t('areYouDelete')"
      :active.sync="popupActive"
      @close="triggerClose"
      ref="popupcontent"
    >
      <p style="padding-bottom: 1rem">{{ $t("willDelete") }}</p>
      <vs-button
        style="font-family: 'Cairo', sans-serif !important"
        @click="deleteData()"
        color="danger"
        class="mr-3"
        type="filled"
        >{{ $t("accept") }}</vs-button
      >
      <vs-button
        style="font-family: 'Cairo', sans-serif !important"
        @click="popupActive = false"
        color="primary"
        type="filled"
        >{{ $t("cancel") }}</vs-button
      >
    </vs-popup>
    <mission-modal
      :active="missionModalActive"
      :title="$t('selectMission')"
      :message="$t('addOrderToMission').replace(':count', selectedOrders.length)"
      :confirm-text="$t('confirm')"
      :selected-orders="selectedOrders"
      :action-loading="missionActionLoading"
      @confirm="confirmAddToMission"
      @close="missionModalActive = false"
    />
    <vs-popup
      class="mission-modal"
      title="إزالة من المهمة"
      :active.sync="removeMissionModalActive"
    >
      <p class="mb-4">سيتم إزالة هذا الطرد من المهمة الحالية</p>
      <div class="flex justify-end">
        <vs-button
          style="font-family: 'Cairo', sans-serif !important"
          class="mr-3"
          color="danger"
          type="filled"
          :disabled="missionActionLoading"
          @click="confirmRemoveFromMission"
        >
          {{ $t('confirm') }}
        </vs-button>
        <vs-button
          style="font-family: 'Cairo', sans-serif !important"
          color="primary"
          type="filled"
          :disabled="missionActionLoading"
          @click="removeMissionModalActive = false"
        >
          {{ $t('cancel') }}
        </vs-button>
      </div>
    </vs-popup>
    <button
      ref="notificationToast"
      :color="notficationColor"
      type="flat"
      style="display: none"
      @click="
        $vs.notify({
          title: notficationTitle,
          text: $t(notficationText),
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check',
        })
      "
    ></button>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import EditData from "../components/table-components/EditData.vue";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";
import globalMixin from "@/mixins/mixins.js";
import helper from "@/mixins/helper.js";
import orderStatusMixin from "@/mixins/orderStatus.js";
import $ from "jquery";
import Modal from "@/layouts/components/Modal.vue";
import ModalRate from "@/layouts/components/ModalRate.vue";
import MissionModal from "@/components/MissionModal.vue";
import ntfClick from "@/mixins/notificationClick.js";
import dateFormat from "@/mixins/date.js";
import gTag from "@/mixins/gtag.js";

export default {
  mixins: [globalMixin, helper, orderStatusMixin, ntfClick, dateFormat, gTag],
  components: {
    EditData,
    SpinnerColor,
    Modal,
    ModalRate,
    MissionModal,
  },
  data() {
    return {
      sidebarDataEdit: null,
      addNewDataSidebarEdit: false,
      id: null,
      pageName: "order/details",
      loading: false,
      popupActive: false,
      errMsg: false,
      showBranchNumber1: false,
      showBranchNumber2: false,
      showBranchNumber3: false,
      loadingCancelation: false,
      popupResend: false,
      popupResendWithSaveOrder: false,
      popupResendWithNewOrder: false,
      orderId: undefined,
      loadingResend: false,
      resendRequestErr: false,
      popupRate: false,
      resendRequestErrMsg: "",
      companySettings: JSON.parse(localStorage.getItem("userData")).company,
      loadingTicket: false,
      order:'',
      // Mission handling
      missionModalActive: false,
      removeMissionModalActive: false,
      selectedMissionId: null,
      availableMissions: [],
      selectedOrders: [],
      missionPage: 1,
      missionSearchQuery: "",
      hasNextPage: false,
      loadingMissions: false,
      missionActionLoading: false,
    };
  },
  computed: {
    ...mapGetters("dataList", [
      "detail_of_order",
      "delay_log",
      "success_api",
      "err_msg",
      "message",
      "success_resend",
    ]),
    ...mapGetters("userData", ["stox_customer_id"]),
    conditionEdit() {
      if (
        this.detail_of_order.client_status === this.statusOfOrder.underway ||
        this.detail_of_order.client_status === this.statusOfOrder.delayed ||
        this.detail_of_order.client_status === this.statusOfOrder.withCaptain ||
        this.detail_of_order.client_status === this.statusOfOrder.saved ||
        this.detail_of_order.client_status === this.statusOfOrder.sent
      ) {
        return true;
      } else {
        return false;
      }
    },
    canBeResent() {
      const returnedStatuses = [
        this.statusOfOrder.returnedWithCompany,
        this.statusOfOrder.ReturnedInBranch,
        this.statusOfOrder.ReturnedToBranch,
        this.statusOfOrder.ReturnedWithCaptain,
      ];

      const isReturnedStatus = returnedStatuses.includes(this.detail_of_order.client_status);
      const isNotDepositOrder = this.detail_of_order.is_order !== 4;
      const isNotResentTwice = !(this.detail_of_order.code && this.detail_of_order.code.includes('NN'));
      return (isReturnedStatus && isNotDepositOrder && isNotResentTwice);
    },
    canBeResentWithNewOrder() {
      const hasProducts = this.detail_of_order.order_products && this.detail_of_order.order_products.length > 0;
      const isStocksCustomer = this.stox_customer_id !== null && this.stox_customer_id !== undefined;
      return this.canBeResent && !hasProducts && !isStocksCustomer;
    },
    canBeCancelled() {
      //قيد التنفيذ
      const underProceesingStatus = [
        this.statusOfOrder.ToCaptain,
        this.statusOfOrder.withCaptain,
        this.statusOfOrder.underway,
        this.statusOfOrder.InBranch,
        this.statusOfOrder.delayed,
        this.statusOfOrder.ToBranch,
      ];
      const isUnderProceesingStatus = underProceesingStatus.includes(this.detail_of_order.client_status);
      return isUnderProceesingStatus;
    },
    success() {
      if (this.success_api === 1) {
        return true;
      } else {
        return false;
      }
    },
    clientRate() {
      switch (this.detail_of_order.client_rate_digit) {
        case 1:
          return "غير راضي جدا";
        case 2:
          return "غير راضي";
        case 3:
          return "عادي";
        case 4:
          return "راضي";
        case 5:
          return "راضي جدا";
      }
    },
  },
  watch: {
    "$route.params.id": {
      async handler() {
        this.loading = true;
        await this.orderDetails(this.$route.params.id);
        await this.orderDelayLog(this.$route.params.id);
        if (
          this.$route.query.popupRate &&
          this.detail_of_order.client_rate_digit == null
        ) {
          this.popupRate = true;
        }
        this.loading = false;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("dataList", [
      "orderDetails",
      "orderDelayLog",
      "deleteOrder",
      "changeOrderStatus",
      "changeOrderStatusSaved",
      "orderCancel",
      "resendRequest",
      "changeToUrgent",
      "resendWithNewOrder",
    ]),
    ...mapActions("ticket", [
      "complainsTypes",
      "setTicketPageIndex",
      "setTypeProblem",
      "toggleShowTicket",
      "setRelatedModel",
      "setTypeTicket",
      "setComplainTypeId",
      "setEntityId",
    ]),
    // Mission handling
    openAddToMissionModal(order) {
      if (!order || !order.id) {
        this.$vs.notify({
          title: "تنبيه",
          text: "يجب اختيار طرد واحد على الأقل",
          color: "warning",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      this.selectedOrders = [order];
      this.selectedMissionId = null;
      this.availableMissions = [];
      this.missionPage = 1;
      this.missionSearchQuery = "";
      this.hasNextPage = false;

      this.fetchMissions();
      this.missionModalActive = true;
    },
    removeFromMission(order) {
      if (!order || !order.id) {
        this.$vs.notify({
          title: "تنبيه",
          text: "يجب اختيار طرد واحد على الأقل",
          color: "warning",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }
      this.selectedOrders = [order];
      this.removeMissionModalActive = true;
    },
    onMissionOpen() {
      if (!this.availableMissions.length) {
        this.fetchMissions();
      }
    },
    onMissionSearch(search) {
      this.missionSearchQuery = search;
      this.missionPage = 1;
      this.availableMissions = [];
      this.fetchMissions();
    },
    async fetchMissions() {
      this.loadingMissions = true;
      try {
        const { data } = await axios.get("mission/pickup/new-missions", {
          params: {
            page: this.missionPage,
            search: this.missionSearchQuery,
          },
        });
        if (data.success) {
          if (this.missionPage === 1) {
            this.availableMissions = data.feed;
          } else {
            this.availableMissions.push(...data.feed);
          }
          this.hasNextPage = data.meta.current_page < data.meta.last_page;
        }
      } finally {
        this.loadingMissions = false;
      }
    },
    loadMoreMissions() {
      this.missionPage++;
      this.fetchMissions();
    },
    async confirmAddToMission(missionId) {
      const missionIdToUse = missionId || this.selectedMissionId;
      if (!missionIdToUse || !this.selectedOrders.length) return;

      const isSingle = this.selectedOrders.length === 1;
      this.selectedMissionId = missionIdToUse;
      this.missionActionLoading = true;
      const orderIds = this.selectedOrders.map((order) => order.id);
      try {
        const response = await axios.post("order/add-to-mission", {
          mission_id: missionIdToUse,
          order_ids: orderIds,
        });

        if (response.data.success) {
          this.$vs.notify({
            title: "????",
            text: isSingle ? "?? ????? ????? ??? ??????" : response.data.message,
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
          });
          await this.orderDetails(this.detail_of_order.code);
        } else {
          this.$vs.notify({
            title: "???",
            text:
              response.data.error_msg ||
              (isSingle
                ? "??? ????? ????? ??????"
                : "??? ????? ?????? ??????"),
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "???",
          text:
            (error.response &&
              error.response.data &&
              error.response.data.error_msg) ||
            (isSingle
              ? "??? ??? ????? ????? ????? ??????"
              : "??? ??? ????? ????? ?????? ??????"),
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
      } finally {
        this.missionActionLoading = false;
        this.missionModalActive = false;
        this.selectedMissionId = null;
        this.selectedOrders = [];
      }
    },
    async confirmRemoveFromMission() {
      if (!this.selectedOrders.length) return;

      const isSingle = this.selectedOrders.length === 1;
      this.missionActionLoading = true;
      const orderIds = this.selectedOrders.map((order) => order.id);

      try {
        const response = await axios.post("order/remove-from-mission", {
          order_ids: orderIds,
        });

        if (response.data.success) {
          this.$vs.notify({
            title: "????",
            text: isSingle ? "?? ????? ????? ?? ??????" : response.data.message,
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
          });

          await this.orderDetails(this.detail_of_order.code);
        } else {
          this.$vs.notify({
            title: "???",
            text:
              response.data.error_msg ||
              (isSingle
                ? "??? ????? ????? ?? ??????"
                : "??? ????? ?????? ?? ??????"),
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "???",
          text:
            (error.response &&
              error.response.data &&
              error.response.data.error_msg) ||
            (isSingle
              ? "??? ??? ????? ????? ????? ?? ??????"
              : "??? ??? ????? ????? ?????? ?? ??????"),
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
      } finally {
        this.missionActionLoading = false;
        this.removeMissionModalActive = false;
        this.selectedOrders = [];
      }
    },
    editData() {
      this.id = this.$route.params.id;
      this.sidebarDataEdit = this.detail_of_order.id;
      this.toggleDataSidebarEdit(true);
    },
    toggleDataSidebarEdit(val = false) {
      this.addNewDataSidebarEdit = val;
    },
    showReason(type) {
      if (type === 1) {
        $("#delay-result1").slideToggle();
        $("#delay_reason_icon1").toggleClass("delay_reason_icon_active");
      } else {
        $("#delay-result2").slideToggle();
        $("#delay_reason_icon2").toggleClass("delay_reason_icon_active");
      }
    },
    triggerClose() {
      this.$refs.popupcontent.$el.children[1].children[1].scrollTop = 0;
    },
    async popupActiveMethod(id) {
      this.popupActive = true;
      this.id = id;
    },
    async deleteData() {
      await this.deleteOrder(this.id);
      this.popupActive = false;
      if (this.$store.state.dataList.successApi === 1) {
        this.notficationTost(true, "deleteToast");
        this.$refs.notificationToast.click();
        this.$router.push("/SavedOrder");
      } else {
        this.notficationTost(false, "FaildDelete");
        this.$refs.notificationToast.click();
      }
    },
    async changeOrderState(id) {
      if (this.detail_of_order.client_status === this.statusOfOrder.saved) {
        this.googleEventTrack(
          "الضغط على اكشن تحويل الى مرسلة",
          "order_details",
          "change_order_status_to_send_action"
        ),
          await this.changeOrderStatus(id);
      } else {
        this.googleEventTrack(
          "الضغط على اكشن تحويل الى محفوظة",
          "order_details",
          "change_order_status_to_saved_action"
        ),
          await this.changeOrderStatusSaved(id);
      }
      if (this.$store.state.dataList.successApi === 1) {
        if (this.detail_of_order.client_status === this.statusOfOrder.saved) {
          this.$router.push("/SentOrder");
        } else {
          this.$router.push("/savedOrder");
        }
        this.notficationTost(true, "doneChangeStatus");
        this.$refs.notificationToast.click();
      } else {
        this.notficationTost(false, "faildDoneChangeStatus");
        this.$refs.notificationToast.click();
      }
    },
    ifFound(data) {
      if (data) {
        return data;
      } else {
        return "لا يوجد";
      }
    },
    toTicket(tickets) {
      if (tickets.length === 1) {
        this.$router
          .push({ path: `/apps/chat/${tickets[0].id}`, query: { type: 1 } })
          .catch(() => {});
      } else {
        this.$router
          .push({
            path: `/Log/${this.detail_of_order.id}/tickets-of-orders`,
            query: { data: tickets },
          })
          .catch(() => {});
      }
    },
    closeBranchesModal(e) {
      if (
        e.target !== this.$refs["more-mobile1"] &&
        e.target !== this.$refs["received-branch-mobile"]
      ) {
        this.showBranchNumber1 = false;
      }
      if (
        e.target !== this.$refs["more-mobile2"] &&
        e.target !== this.$refs["current-branch-mobile"]
      ) {
        this.showBranchNumber2 = false;
      }
      if (
        e.target !== this.$refs["more-mobile3"] &&
        e.target !== this.$refs["exec-branch-mobile"]
      ) {
        this.showBranchNumber3 = false;
      }
    },
    async orderCancelation(type) {
      if (type == 1) {
        this.googleEventTrack(
          "الضغط على اكشن طلب الغاء الطلب",
          "order_details",
          "request_cancel_order"
        );
      } else {
        this.googleEventTrack(
          "الضغط على اكشن الغاء طلب الالغاء",
          "order_details",
          "cancel_request_cancel_order"
        );
      }
      this.loadingCancelation = true;
      await this.orderCancel({ type: type, id: this.detail_of_order.id });
      if (this.success) {
        await this.orderDetails(this.detail_of_order.code);
      }
      this.loadingCancelation = false;
    },
    closePopup() {
      this.popupResend = false;
      this.popupResendWithSaveOrder = false;
      this.popupRate = false;
      this.popupResendWithNewOrder = false;
    },
    async resendOrderRequest(type) {
      this.googleEventTrack(
        "الضغط على طلب اعادة الارسال",
        "order_details",
        "resend_order_request"
      );
      this.loadingResend = true;
      if (this.detail_of_order.sending == 0) {
        this.resendRequestErrMsg = "";
        this.resendRequestErr = false;
        if(this.popupResendWithNewOrder && type == 2){
          this.popupResendWithNewOrder = false;
          this.resendWithNewOrder(this.detail_of_order);
          this.closePopup();
          this.$router.push("/addOrder");
        } else {
          const obj = {
            id: this.detail_of_order.id,
            type: type,
            orderId: this.orderId,
          };
          await this.resendRequest(obj);
          if (this.success_resend == 1) {
            await this.orderDetails(this.$route.params.id);
            this.resendRequestErr = false;
            this.closePopup();
            this.notficationTost(true, "تم طلب إعادة الارسال بنجاح");
            this.$refs.notificationToast.click();
          } else {
            this.resendRequestErr = true;
          }
        }
      } else {
        this.resendRequestErr = true;
        this.resendRequestErrMsg = this.$t('repetedResendrequest');
      }
      this.loadingResend = false;
    },

    async addNewTicket() {
      this.loadingTicket = true;
      await this.complainsTypes();
      this.loadingTicket = false;
      this.toggleShowTicket();
      this.setTicketPageIndex(3);
      this.setTypeProblem(1);
      this.setTypeTicket(2);
      this.setComplainTypeId(1);
      this.setRelatedModel(0);
      this.setEntityId(this.$route.params.id);
    },

    async urgentOrder() {
      this.loadingCancelation = true;
      await this.changeToUrgent(this.detail_of_order.id);
      if (this.success) {
        await this.orderDetails(this.detail_of_order.code);
      }
      this.loadingCancelation = false;
    },
  },
  async created() {
    this.loading = true;
    
    await this.orderDetails(this.$route.params.id);
   
    await this.orderDelayLog(this.$route.params.id);
    if (
      this.$route.query.popupRate &&
      this.detail_of_order.client_rate_digit == null
    ) {
      this.popupRate = true;
    }
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";
@import "@/assets/scss/vuexy/_loadingTable.scss";
@import "@/assets/scss/vuexy/_orderDetails.scss";
.loaderSpinner {
  position: fixed;
  top: 65%;
  right: 50%;
  z-index: 9;
  .loader {
    width: 2.5rem;
    height: 2.5rem;
  }
}
</style>
<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";
</style>
